import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../auth/AuthContext";

const Field = ({ label, name, value, onChange, type = "text", placeholder, testid }) => (
  <div className="space-y-1">
    <label className="text-[10px] uppercase tracking-[0.2em] text-muted-3 font-mono-data">
      {label}
    </label>
    <input
      name={name}
      type={type}
      value={value || ""}
      onChange={onChange}
      placeholder={placeholder}
      data-testid={testid}
      className="w-full bg-transparent border border-grid px-3 py-2 text-sm focus:outline-none focus:border-white/40"
    />
  </div>
);

export const ProfileSetup = () => {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    display_name: user?.profile?.display_name || user?.name || "",
    full_name: user?.profile?.full_name || "",
    phone: user?.profile?.phone || "",
    pan: user?.profile?.pan || "",
    city: user?.profile?.city || "",
  });
  const [saving, setSaving] = useState(false);

  const update = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.display_name || !form.full_name || !form.phone || !form.pan || !form.city) {
      toast.error("All fields are required.");
      return;
    }
    setSaving(true);
    try {
      await api.put("/auth/profile", form);
      const u = await refresh();
      toast.success("Profile saved.");
      if (!u?.legal_accepted) {
        navigate("/legal-acceptance", { replace: true });
      } else {
        navigate(u?.status === "ACTIVE" ? "/dashboard" : "/pending", { replace: true });
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Save failed.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg-primary)" }}>
      <div className="w-full max-w-lg space-y-6 border border-grid p-8" data-testid="profile-setup-page">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-muted-3 font-mono-data mb-1">
            Welcome to StoxTrade
          </div>
          <h1 className="font-heading text-2xl">Tell us about yourself</h1>
          <p className="text-xs text-muted-2 mt-2">
            Required to access the dashboard. Your details stay private and are used
            only for KYC + compliance once payments go live.
          </p>
        </div>
        <form className="space-y-4" onSubmit={submit}>
          <Field label="Display Name" name="display_name" value={form.display_name} onChange={update}
                 placeholder="What should we call you?" testid="profile-display-name" />
          <Field label="Full Name" name="full_name" value={form.full_name} onChange={update}
                 placeholder="As per PAN" testid="profile-full-name" />
          <Field label="Phone" name="phone" value={form.phone} onChange={update}
                 placeholder="+91 90000 00000" testid="profile-phone" />
          <Field label="PAN" name="pan" value={form.pan} onChange={update}
                 placeholder="ABCDE1234F" testid="profile-pan" />
          <Field label="City" name="city" value={form.city} onChange={update}
                 placeholder="Bengaluru" testid="profile-city" />
          <button
            type="submit"
            disabled={saving}
            data-testid="profile-submit"
            className="w-full px-4 py-3 border text-[11px] uppercase tracking-[0.2em] font-mono-data"
            style={{ color: "var(--bull)", borderColor: "var(--bull)" }}
          >
            {saving ? "Saving..." : "Save & Continue →"}
          </button>
        </form>
      </div>
    </div>
  );
};
